import type { FCSUser, StreamType } from '../../../types'
import { safeDecodeUriComponent } from '../../utilities/safeDecodeUriComponent'
import {
    CHANNEL_ID_START,
    SESSCHAN_ID_END,
    SESSCHAN_ID_START,
} from '../mfcConstants'

export const channelFromID = (id: number) => id + CHANNEL_ID_START
export const idFromChannel = (channel: number) => {
    if (SESSCHAN_ID_START < channel && channel < SESSCHAN_ID_END) {
        return channel - SESSCHAN_ID_START
    }
    return channel - CHANNEL_ID_START
}
export const isMissMFCTop = (
    isMissMFC: boolean,
    missMFCRank: number,
    limit: number,
) => {
    if (!isMissMFC || !missMFCRank) {
        return null
    }

    return missMFCRank <= limit
}
export const isNewModel = (newModel: number) => {
    if (!newModel) return false
    return parseInt(newModel.toString(), 10) === 1
}
export const resolveChannel = (id: number, streamType?: StreamType) => {
    if (!id) return
    if (!streamType || streamType === 'public' || streamType === 'voyeur') {
        return channelFromID(id)
    }
    return resolveSessionChannel(id)
}
export const resolveColor = (color: string) => {
    if (!color) return null
    return '#' + color
}
export const resolveContinent = (continent: string) => continent || 'unknown'
export const resolveCreation = (creation: number) => creation || 0
export const resolveLastNewsTimestamp = (timestamp: number) =>
    timestamp > 0 ? timestamp * 1000 : timestamp
export const resolveName = (name: string) => name || ''
export const resolveRank = (rank: number) => rank || 0
export const resolveScore = (camScore: number) => {
    if (!camScore || parseInt(camScore.toString(), 10) < 0) return 0
    return camScore | 0
}
export const resolveSessionChannel = (uid: number) => uid + SESSCHAN_ID_START
export const resolveSlugFromName = (nm: string) => {
    if (!nm) return ''
    return nm.toLowerCase()
}
export const resolveSlugFromUser = (user: FCSUser, supplied?: string) => {
    if (supplied) {
        return supplied
    }
    const { nm: name = '', slug } = user
    return (slug || name).toLowerCase()
}
export const resolveTopic = (topic: string) => {
    if (!topic) return ''
    return safeDecodeUriComponent(topic)
}
export const resolveViewers = (viewers: number) => viewers || 0
export const isPopular = (viewers: number) => {
    if (!viewers) {
        return false
    }

    return viewers > 25
}
